import React from 'react';
import _ from 'lodash';

import SectionHeader from '../SectionHeader';
import ProductCard from '../ProductCard';

export default class ProductPricingSection extends React.Component {
  render() {
    const { titleText, titleDescription, products } = this.props;

    return (
      <div>
        <div className="ui container p-b-4">

          <SectionHeader titleText={titleText} titleDescription={titleDescription} />

          <div className="ui grid centered">
            <div className="stretched row">
              {_.map(products, (product, index) => (
                <div key={index} className="four wide computer four wide tablet eight wide mobile column p-b-1-m">
                  <ProductCard product={product} />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="ui fitted divider" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/ProductPricingSection/index.jsx